import React from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { SSH_Buttons } from "../../../../components/molecules/Buttons/Buttons.component";
import { useBackgroundColor } from "../../../../hooks/useBackgroundColor/useBackgroundColor.hook";
import { usePadding } from "../../../../hooks/usePadding/usePadding.hook";
import { useWebsiteType } from "../../../../hooks/useWebsiteType.hook";
import { V1Props } from "./TextV1.interface";
import { useAlignment } from "./hooks/useAlignment.hook";
// eslint-disable-next-line css-modules/no-unused-class
import S from "./TextV1.module.scss";

const V1 = (props: V1Props) => {
    const { websiteTypeClass } = useWebsiteType(S);

    const { backgroundColorClass, alternativeButtonTheme, hasBackgroundColor } = useBackgroundColor(
        props.backgroundColor
    );
    const { paddingClass } = usePadding(props.isCompact, hasBackgroundColor);
    const { alignmentClass, isAlignmentCenter } = useAlignment(props.alignment, S);

    return (
        <div
            className={cn(
                S.wrapper,
                paddingClass,
                backgroundColorClass,
                alignmentClass,
                websiteTypeClass
            )}
        >
            <DA_Container noVerticalPadding>
                <div className={S.inner}>
                    {/** Tagline */}
                    {props.tagline ? <span className={S.tagline}>{props.tagline}</span> : null}

                    {/** Title */}
                    {props.headline ? (
                        <DA_Title h2 tag={DA_TitleTag.H2} noMargin fullWidth>
                            {props.headline}
                        </DA_Title>
                    ) : null}

                    {/** Text */}
                    {props.text ? (
                        <DA_Text html={props.text} noPadding alignCenter={isAlignmentCenter} />
                    ) : null}

                    {/** Buttons */}
                    <SSH_Buttons buttons={props.buttons} theme={alternativeButtonTheme} />
                </div>
            </DA_Container>
        </div>
    );
};

export default V1;
